export default __webpack_public_path__ + "static/heroImg-2942f47d2c083c772c40446a335c84d3.png";